<template>
    <div id="labSignupDiv">
        <HeaderVue />
        <div class="inner-page phleb-signup">
            <div class="container">
                <div class="row">
                    <div class="col-sm-8">
                        <div class="lab-benefits">
                            <h2 class="mb-3">Partner With Us</h2>
                            <p class="mb-5" style="line-height: 22px; margin-bottom:10px;">A unique initiative for mutual growth of <br>your lab & Labotist</p>
                            <ul>
                                <li>
                                    <span class="number-circle">1</span>Experience significant visibility online.</li>
                                <li>
                                    <span class="number-circle">2</span>Gain access to trained & efficient phlebotomists providing high quality of service leading to increased customer satisfaction.</li>
                                <li>
                                    <span class="number-circle">3</span>Eliminate the burden and expenditure on marketing, inventory management, and
                                    logistical aspects involved in transportation of samples between the patient’s homes and the lab, allowing for labs to focus on their core strengths.</li>
                                <li>
                                    <span class="number-circle">4</span>Design your product offerings based on the market intelligence and customer feedback shared by Labotist Data Sciences Team.</li>
                                <li>
                                    <span class="number-circle">5</span>Labotist will take care of customer care, training and payroll of the phlebotomists, while you focus on patients.</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="sign-up">
                            <div class="signup-title">
                                <h4>Partner With Us</h4>
                                <p>Sign Up Today</p>
                            </div>
                            <div class="form-content line-textbox">
                                <form data-vv-scope="signup">
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="pincode" id="pincode" v-model="pincode" data-vv-as="pincode" v-validate="'required|numeric|min:6|max:6'" placeholder="Pincode (Chennai & Bengaluru)">
                                        <span v-show="errors.has('signup.pincode')" class="text-danger">{{ errors.first('signup.pincode') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="labname" id="labname" v-model="labname" data-vv-as="lab name" v-validate="'required|max:250'" placeholder="Lab Name">
                                        <span v-show="errors.has('signup.labname')" class="text-danger">{{ errors.first('signup.labname') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="contact" id="contact" v-model="contact" data-vv-as="contact name" v-validate="'required|alpha_spaces|max:100'" placeholder="Contact Person Name">
                                        <span v-show="errors.has('signup.contact')" class="text-danger">{{ errors.first('signup.contact') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="email" name="email" id="email" v-model="email" data-vv-as="email address" v-validate="'required|email'" placeholder="Email Address">
                                        <span v-show="errors.has('signup.email')" class="text-danger">{{ errors.first('signup.email') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="phone" id="phone" v-model="phone" data-vv-as="phone no." v-validate="'required|numeric|max:10|min:10'" placeholder="Phone No">
                                        <span v-show="errors.has('signup.phone')" class="text-danger">{{ errors.first('signup.phone') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="fax" id="fax" v-model="fax" data-vv-as="fax no." v-validate="'numeric|max:10|min:10'" placeholder="Fax No">
                                        <span v-show="errors.has('signup.fax')" class="text-danger">{{ errors.first('signup.fax') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="address" id="address" v-model="address" data-vv-as="lab address" v-validate="'required'" placeholder="Address">
                                        <span v-show="errors.has('signup.address')" class="text-danger">{{ errors.first('signup.address') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="city" id="city" v-model="city" data-vv-as="city" v-validate="'required|alpha_spaces|max:100'" placeholder="City">
                                        <span v-show="errors.has('signup.city')" class="text-danger">{{ errors.first('signup.city') }}</span>
                                    </div>
                                    <div class="form-group">
                                        <input class="form-control" type="text" name="state" id="state" v-model="state" data-vv-as="state" v-validate="'required|alpha_spaces|max:100'" placeholder="State">
                                        <span v-show="errors.has('signup.state')" class="text-danger">{{ errors.first('signup.state') }}</span>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-6">
                                            <button class="btn  btn-link full-width" @click.prevent="reset()" type="reset">Reset</button>
                                        </div>
                                        <div class="col-sm-6">
                                            <button class="btn btn-primary full-width" @click.prevent="save()" :disabled="(errors.any())">Send</button>                                        
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <FooterVue />
    </div>
</template>

<script>
import HeaderVue from '@/components/web/Header'
import FooterVue from '@/components/web/Footer'

export default {
  name: 'Labsignup',
  components: {
    HeaderVue,
    FooterVue
  },
  beforeCreate () { },
  data () {
    return {
      pincode: '',
      labname: '',
      contact: '',
      phone: '',
      email: '',
      fax: '',
      address: '',
      city: '',
      state: '',
      success: false
    }
  },
  methods: {
    save: function () {
      this.$validator.validateAll('signup').then(function (result) {
        if (result) {
          try {
            let data = {
              labName: this.labname,
              contactPersonName: this.contact,
              emailAddress: this.email,
              phoneNumber: this.phone,
              faxNumber: this.fax,
              address: this.address,
              cityName: this.city,
              stateName: this.state,
              pincode: this.pincode
            }
            Promise.resolve(this.$POST('patient/labSignup', data)).then(function (res) {
              if (res.response_code === 0) {
                this.success = true
                this.$Simplert.open({
                  title: 'Success',
                  message: `Thanks for contact us. We will touch with you soon.`,
                  type: 'warning',
                  disableOverlayClick: true,
                  showXclose: true,
                  useConfirmBtn: false,
                  customCloseBtnText: 'OK'
                })
                this.reset()
                // location.reload()
              }
            }.bind(this)).catch(function (err) {
              console.error(err)
              this.$Simplert.open({
                title: 'Oops',
                message: `Something went wrong please mail us support@labotist.com`,
                type: 'warning',
                disableOverlayClick: true,
                showXclose: true,
                useConfirmBtn: false,
                customCloseBtnText: 'OK'
              })
              // alert('Something went wrong please mail us support@labotist.com')
            }.bind(this))
          } catch (e) {
            console.error(e)
          }
        }
      }.bind(this)).catch(() => {
        console.log('errors exist while save lab form', this.errors)
      })
    },
    reset: function () {
      this.pincode = ''
      this.labname = ''
      this.contact = ''
      this.email = ''
      this.phone = ''
      this.fax = ''
      this.address = ''
      this.city = ''
      this.state = ''
      setTimeout(function () {
        this.errors.items = []
      }.bind(this), 30)
    }
  },
  mounted () {
    this.$hidePageLoading()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.help.is-danger {
    color: red;
}
.close, .btn {
    cursor: pointer;
}
.submitted {
  color: #4fc08d;
}
</style>


// WEBPACK FOOTER //
// src/components/web/Public/Labsignup.vue